import { render, staticRenderFns } from "./examUnitsDialog.vue?vue&type=template&id=8070fe8c&scoped=true"
import script from "./examUnitsDialog.vue?vue&type=script&lang=js"
export * from "./examUnitsDialog.vue?vue&type=script&lang=js"
import style0 from "./examUnitsDialog.vue?vue&type=style&index=0&id=8070fe8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8070fe8c",
  null
  
)

export default component.exports